export * from './persistAppLockedDealImpressionsCount'
